type IfPropsType = {
    condition: any | (() => any),
    children: React.ReactNode | React.ReactNode[]
}
const If = (props: IfPropsType) => {
    if(!props.condition) return <></>;
    if(typeof props.condition == 'function' && !props.condition()) return <></>;

    return (
        <>
            {props.children}
        </>
    );
};
export default If;
